import {useState} from 'react'
import {useParams} from 'react-router-dom'
import useLoginCookie from 'shared/model/useLoginCookie'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePostEventTemplate = () => {
	const [fetchResult, setFetchResult] = useState(null)
	const {idx} = useParams()
	const [cookie] = useLoginCookie()
	const [userRole] = useRoleCookie()

	const uploadFile = async (file) => {
		if (file && cookie) {
			try {
				const formData = new FormData()
				formData.append('file', file)
				formData.append('event_idx', idx)
				const rolePath = getApiRolePath(userRole)
				let url = `${process.env.REACT_APP_BACKEND_URL}/${rolePath}/seed-ticket/import`

				const response = await fetch(url, {
					method: 'POST',
					headers: {
						token: cookie,
					},
					body: formData,
				})

				if (response.ok) {
					const result = await response.json()
					setFetchResult({
						statusCode: 200,
						data: result,
					})
				} else {
					const errorResult = await response.json()
					setFetchResult({
						statusCode: response.status,
						data: errorResult,
					})
				}
			} catch (error) {
				setFetchResult({
					statusCode: 500,
					data: {message: error.message || '네트워크 오류가 발생했습니다.'},
				})
			}
		}
	}

	const resetResult = () => setFetchResult(null)

	return [fetchResult, uploadFile, resetResult]
}

export default usePostEventTemplate
